// sourceCodeMenu.js
import { Boot } from '@wangeditor/editor';
// import DOMPurify from 'dompurify';
import store from '@/store'

class SourceCodeMenu {
    constructor() {
        this.type = 'button';
        this.title = '源码';
        this.tag = 'button';
        this.iconSvg = `<svg viewBox="0 0 1024 1024" width="20" height="20">
      <path d="M128 128h768v768H128V128zM256 256v512h512V256H256zM384 384h256v64H384v-64zM384 512h256v64H384v-64z" fill="currentColor"/>
    </svg>`;
        this._isActive = false;
        this._originalPosition = null;
        this._container = null;
    }

    getValue() { return ''; }

    isDisabled(editor) {
        void editor;
        return false;
    }
    isActive() { return this._isActive; }

    exec(editor, _value) {
        void _value;

        // 核心修改：使用 editor.getEditableContainer() 替代 editor.getContainer()
        if (!this._container) {
            this._container = editor.getEditableContainer();
        }
        const container = this._container;
        if (!container) return ;

        const isSourceMode = container.getAttribute('data-source-mode') === 'true';

        if (!isSourceMode) {
            const html = editor.getHtml();
            const textarea = document.createElement('textarea');
            textarea.value = html;
            textarea.className = 'source-code-editor';
            textarea.style.cssText = `
                position: absolute;
                top:0;;
                left:0;
                width: 100%;
                height: 100%;
                min-height: 500px;
                font-family: monospace;
                font-size: 14px;
                padding: 10px;
                border: none;
                outline: none;
                resize: vertical;
                background: #f5f5f5;
                box-sizing: border-box;
                z-index: 10;
              `;

            // 确保容器有相对定位，以便 textarea 能绝对定位覆盖
            if (window.getComputedStyle(container).position === 'static') {
                container.style.position = 'relative';
            }

            // 隐藏编辑器原有的可编辑区域，避免重叠
            const editArea = container.querySelector('[contenteditable="true"]');
            if (editArea) editArea.style.display = 'none';

            // 移除可能存在的旧 textarea，然后添加新的
            const oldTextarea = container.querySelector('.source-code-editor');
            if (oldTextarea) oldTextarea.remove();
            container.appendChild(textarea);

            container.setAttribute('data-source-mode', 'true');
            this._isActive = true;

        } else {

            const textarea = container.querySelector('.source-code-editor');
            if (textarea) {
                const rawHtml = textarea.value;
                const cleanHtml = rawHtml;
                // const cleanHtml = DOMPurify.sanitize(rawHtml, {
                //     ALLOWED_TAGS: [ 'p', 'div', 'span', 'br', 'hr', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'b', 'em', 'i', 'u', 's', 'del', 'a', 'img', 'ul', 'ol', 'li', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'pre', 'code', 'blockquote', 'font', 'iframe' ],
                //     ALLOWED_ATTR: [ 'href', 'src', 'alt', 'title', 'width', 'height', 'class', 'id', 'style', 'target', 'rel' ],
                //     ALLOW_DATA_ATTR: false
                // });
                editor.setHtml(cleanHtml);
                store.state.content = cleanHtml;
                textarea.remove();
            }
            const editArea = container.querySelector('[contenteditable="true"]');
            if (editArea) editArea.style.display = '';
            container.setAttribute('data-source-mode', 'false');
            this._isActive = false;
        }
    }
}

SourceCodeMenu.key = 'sourceCodeMenu'
Boot.registerMenu({
    key: SourceCodeMenu.key,
    factory() { return new SourceCodeMenu() }
})

export default SourceCodeMenu
